export default "__VITE_ASSET__CNDjFkAi__"